const NotificationTypes = Object.freeze({
    SUCCESS: 'success',
    WARN: 'warn',
    ALERT: 'alert',
    INFO: 'info'
});

export default NotificationTypes;
